// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__33DeM","log":"ModalInventoryLogs_log__2exVF","date":"ModalInventoryLogs_date__3iin6","userName":"ModalInventoryLogs_userName__3qLOQ"};